export enum EServicesNames {
  CONSULTING = "it-consulting",
  DEVELOPMENT = "software-development",
  SUPPORT = "software-implementation-and-support",
  ERP = "erp-software-development-services",
  CRM = "crm-software-development-services",
  SOFTWARE_DEVELOPMENT_SERVICES = "software-development-services",
}
